import { render } from "./Game.vue?vue&type=template&id=4193765c"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=4193765c&scss=true&lang=css"

import exportComponent from "E:\\project2\\skin-web\\觉醒守卫之战\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__